import { useState } from 'react';
import PageBodyWrapper from '../../components/PageBodyWrapper'
import { SearchAndFilterToolbar } from '../../components/common';
import { useSearchParams } from 'react-router-dom';
import StockReservationTable from '../../components/stocks/stockReservationTable';
import useApi from '../../api';
import StockFilter from '../../components/stocks/StockFilter';
import { getQueryVariables } from '../../utils';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";

const GET_STOCK_RESERVATION = gql`
  query MyQuery(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    stockReservations(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          dbId
          purpose
          quantity
          stock {
            productVariant {
              displayName
            }
            warehouse {
              name
            }
          }
        }
      }
    }
  }
`;

function StockReservation() {
  const [stocks, setStocks] = useState<any>()
  const [isOpenStockCreateForm, setIsOpenStockCreateForm] = useState<boolean>(false)
  const [isOpenStockFilter, setISOpenStockFilter] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStatus = searchParams.get("status");
  const api = useApi()
  
  const [filterData, setFilterData] =  useState<any>({});

  const { data, loading, error, refetch } = useQuery(GET_STOCK_RESERVATION, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });





  return (
    <PageBodyWrapper>
      
      
      <SearchAndFilterToolbar
        onFilterOpen={() => setISOpenStockFilter(!isOpenStockFilter)}
        onRefresh={refetch}
        onClearFilters={() => setFilterData({})}
        startDateKey={"created_at_after"}
        endDateKey={"created_at_before"}
      />

      {isOpenStockFilter && <StockFilter isOpen={isOpenStockFilter} onClose={()=>setIsOpenStockCreateForm(!isOpenStockFilter)}/>}

      <StockReservationTable data={data?.stockReservations?.edges || []} refresh={refetch}/>

      {/* <Paginator data={data?.allSto}/> */}
      
    </PageBodyWrapper>
  )
}

export default StockReservation